import React, {
} from 'react';
import cache from '@/cache';
import {
  octSettings,
  octBoundsDeg,
} from '@/imageFiles';
import {
  Coord,
  ImageConfig,
} from '@t/LayoutTypes';
import * as common from '@/common';
import * as elements from '@svg/elements';
import useWizardStore from '@zs/useWizardStore';


interface RetinalOverlayProps {
  eye: 'OD' | 'OS';
  scanIndex: number;
  bscanX: number;
  blend: number;
}
export const RetinalOverlay = ({
  eye,
  scanIndex,
  bscanX,
  blend,
}: RetinalOverlayProps): JSX.Element => {
  const registration = useWizardStore(state => state.registrations[eye]);
  const fovea = useWizardStore(state => state.fovealPit[eye]);

  const {
    BSCAN,
    RED,
    FAF,
    FAFONH,
  } = cache.images[eye]!;

  const scaleRED = octSettings.enfaceAngle / RED.crop.width;
  const fovDeg = elements.getFoveaDeg(fovea, BSCAN.crop.width);
  const scanCoord = elements.getEnfaceDeg(bscanX, scanIndex);

  const enfaceLines: JSX.Element = <>
    <line x1={scanCoord.x} y1={0} x2={scanCoord.x} y2={octSettings.enfaceAngle} stroke='#FF0' strokeWidth={elements.strokeWidthDeg} opacity={0.5} />
    <line x1={octBoundsDeg.xMin} y1={scanCoord.y} x2={octBoundsDeg.xMax} y2={scanCoord.y} stroke='#0F0' strokeWidth={elements.strokeWidthDeg} opacity={0.5} />
  </>;

  return (
    <g transform={`translate(${-fovDeg.x}, ${-fovDeg.y})`}>
      <g transform={`scale(${scaleRED})`}>
        {elements.renderCropped(BSCAN.urls[scanIndex], RED.crop)}
        <g opacity={blend}>
          {elements.makeRegTransform(registration.FAFONH, elements.renderCropped(FAFONH.url, FAFONH.crop))}
          {elements.makeRegTransform(registration.FAF, elements.renderCropped(FAF.url, FAF.crop))}
        </g>
      </g>
      {scanBox}
      {enfaceLines}
      {elements.renderFoveal(fovDeg)}
    </g>
  );
};


const scanBox = elements.renderScanBox();
